import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Toast, useConfirm } from '@pletly/ui';
import { getName } from '@pletly/shared';
import { useArchiveMemberMutation } from './__generated__/archiveMember.mutation.generated';

type MemberToArchive = {
	memberId: string;
} & Parameters<typeof getName>[0];

export const useArchiveMember = () => {
	const [archiveMember] = useArchiveMemberMutation();
	const { t } = useTranslation();
	const { confirm } = useConfirm();

	const handleArchive = useCallback(
		async ({ memberId, ...memberNames }: MemberToArchive) => {
			const name = getName(memberNames);
			const confirmation = await confirm(
				t('confirmations.archive-organisation-member.title'),
				t('confirmations.archive-organisation-member.content', {
					name,
				}),
			);
			if (!confirmation) {
				return;
			}

			try {
				await archiveMember({ variables: { id: memberId } });
				Toast.show({
					type: 'success',
					text1: t('toasts.success.member-archived'),
				});
			} catch {
				Toast.show({
					type: 'error',
					text1: t('toasts.error.something-wrong'),
				});
			}
		},
		[t, confirm, archiveMember],
	);

	return { handleArchive };
};
